import type { ChildCartArticleType } from 'services/types';

/** Calculates the unit and total prices for a child article, optionally using its live quantity. */
export function getChildArticlePriceDetails(childArticle: ChildCartArticleType, quantity = childArticle.quantity) {
  const unitPriceChildArticle =
    childArticle.quantity > 0
      ? childArticle.summaryPriceGross / childArticle.quantity
      : childArticle.product.priceGrossUnitRaw;
  const totalPriceChildArticle = unitPriceChildArticle * quantity;

  return {
    unitPriceChildArticle,
    totalPriceChildArticle
  };
}
